<ic-loader></ic-loader>
<ic-layout-top>
  <ic-layout>
    <ic-sidebar></ic-sidebar>
  </ic-layout>
</ic-layout-top>
